import React, { useState } from 'react';
import { COOKIE_NAMES, DEFAULT_AVATAR } from '@gtintel/platform-constants';
import { MemberCard } from '@gtintel/platform-molecules';
import { UserRole } from '@gtintel/platform-types';
import { getSessionStorageItem } from '@gtintel/platform-utils';
import AddTeamMembersToProjectModal from './AddTeamMembersToProjectModal';
import { AddMember, Container, MembersContainer, SubTitle, Title } from './styles';
const ProjectMembers = ({
  onAddMemberToProject,
  onRemoveMemberFromProject,
  project
}) => {
  const [addMemberToTeam, setAddMemberToTeam] = useState(false);
  if (!project) return null;
  const handleAddMemberToTeamClick = () => {
    setAddMemberToTeam(!addMemberToTeam);
  };

  // If you're not logged in then this component shouldn't be rendered in the
  // first place - but guard against it to prevent weird errors during logout.
  const user = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);
  if (!user) return null;
  const isAnonymous = user.is_network_partner && project.request_anonymity;
  const getMember = member => {
    return isAnonymous ? {
      id: member?.id,
      first_name: 'Anonymous',
      last_name: 'Client',
      avatar: DEFAULT_AVATAR,
      team_id: null,
      role: null
    } : member;
  };
  const members = project.members.filter(m => m.is_active);
  return <>
      <Container data-testid="ProjectMembers">
        <Title data-public>Project Members</Title>
        <SubTitle data-public>
          {user.is_network_partner ? 'Client Team: ' : 'Team: '}
          {isAnonymous ? 'Anonymous' : project?.client?.team_name}
        </SubTitle>
        <MembersContainer>
          {members.map(member => <MemberCard key={member.id} member={getMember(member)} description={isAnonymous ? null : UserRole[member.role]} canRemove={!user.is_network_partner && members.length > 1} onRemove={async () => {
          await onRemoveMemberFromProject(project.id, member?.id);
        }} />)}
        </MembersContainer>
        {user.is_network_partner ? <div style={{
        height: 100
      }}></div> : <AddMember>
            <button onClick={handleAddMemberToTeamClick}>
              + ADD TEAM MEMBER TO PROJECT
            </button>
          </AddMember>}
      </Container>
      <AddTeamMembersToProjectModal project={project} teamId={project.client?.team_id} title="Add New Member" subtitle="Invite people to join your project" isVisible={addMemberToTeam} onOk={async data => {
      setAddMemberToTeam(false);
      await onAddMemberToProject(data, project.id);
      handleAddMemberToTeamClick();
    }} onCancel={handleAddMemberToTeamClick} />
    </>;
};
export const ProjectPartner = ({
  project
}) => {
  if (!project) return null;

  // If you're not logged in then this component shouldn't be rendered in the
  // first place - but guard against it to prevent weird errors during logout.
  const user = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);
  if (!user) return null;
  return <Container>
      {user.is_network_partner ? <div style={{
      height: 100
    }}></div> : <>
          <SubTitle>Network Partners</SubTitle>
          <MembersContainer style={{
        marginBottom: '44px'
      }}>
            {project.partner ? <MemberCard member={project.partner} description="Network Partner" /> : <p data-public>No partner has been matched yet</p>}
          </MembersContainer>
        </>}
    </Container>;
};
export default ProjectMembers;